<div
  *ngIf="status"
  class="cg-flex-vertical-center"
  [class.cg-font-size-m]="size === 'medium'"
  [class.cg-font-size-ml]="size === 'large'"
>
  <cigna-icon
    *ngIf="['PTRESTIMATE', 'PAID', 'PROCESSED', 'APPROVED'].includes(status)"
    [class.cg-icon-sm]="size === 'small'"
    [class.cg-icon-md]="size === 'medium'"
    [class.cg-icon-lg]="size === 'large'"
    class="cg-color-digital-green cg-margin-right-sm"
    type="checkmark-circle-outline"
  ></cigna-icon>
  <cigna-icon
    *ngIf="['DENIED', 'REJECTED', 'PTRESTIMATEDENIED'].includes(status)"
    [class.cg-icon-sm]="size === 'small'"
    [class.cg-icon-md]="size === 'medium'"
    [class.cg-icon-lg]="size === 'large'"
    class="cg-color-digital-red cg-margin-right-sm"
    type="exclamation-circle"
  ></cigna-icon>
  <cigna-icon
    *ngIf="
      [
        'IN_PROCESS',
        'PENDED',
        'DUPLICATE',
        'ADJUSTED',
        'PTRESTIMATEPENDING'
      ].includes(status)
    "
    [class.cg-icon-sm]="size === 'small'"
    [class.cg-icon-md]="size === 'medium'"
    [class.cg-icon-lg]="size === 'large'"
    class="cg-color-digital-orange-dark cg-margin-right-sm"
    type="exclamation-triangle"
  ></cigna-icon>

  <div>
    <span>{{ ClaimStatus[status] || status }}</span>
  </div>
</div>
